/*
 * Öffnet die Modalbox mit dem EU-Gewährleistungslabel (snippets/legal-guarantee-modal.liquid).
 *
 * Auslöser sind:
 * - jedes Element mit data-legal-guarantee (Block 'legal-guarantee', Custom Liquid),
 * - Links auf den Anker #gesetzliche-gewaehrleistung bzw. #legal-guarantee,
 * - Links auf die in den Theme-Einstellungen hinterlegte Gewährleistungs-Seite
 *   (z. B. ein Eintrag im Footer-Menü).
 *
 * Ohne JavaScript bleibt ein Menü-Link ein gewöhnlicher Link auf diese Seite,
 * die Mitteilung ist also weiterhin mit einem Klick erreichbar.
 */
(() => {
  const MODAL_ID = 'LegalGuaranteeModal';
  const HASHES = ['#gesetzliche-gewaehrleistung', '#legal-guarantee'];

  const normalize = (path) => (path || '').toLowerCase().replace(/\/+$/, '');

  const pagePath = () => {
    const modal = document.getElementById(MODAL_ID);
    return modal ? normalize(modal.dataset.pageUrl) : '';
  };

  const isTrigger = (link) => {
    const href = (link.getAttribute('href') || '').toLowerCase();
    if (HASHES.some((hash) => href.endsWith(hash))) return true;

    // Reine Sprungmarken zeigen auf den eigenen Pfad und würden sonst auf der
    // Gewährleistungs-Seite selbst fälschlich als Auslöser gelten.
    if (href.startsWith('#')) return false;

    // Menü-Links auf die Gewährleistungs-Seite, inklusive Sprach-Präfix wie /en/pages/…
    const page = pagePath();
    if (!page) return false;

    const path = normalize(link.pathname);
    return path === page || path.endsWith(page);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('[data-legal-guarantee]');
      const link = trigger || event.target.closest('a[href]');
      if (!link || (!trigger && !isTrigger(link))) return;

      const modal = document.getElementById(MODAL_ID);
      if (!modal || typeof modal.showDialog !== 'function') return;

      event.preventDefault();
      modal.showDialog();
    },
    true
  );
})();
